module.exports = __webpack_public_path__ + "img/window-cart.4ac3793d.svg";